import { Nullable } from "../../../types/common";
import { UsersSearchForm } from "./users-search-form.interface";

export function createUsersSearchForm(
  searchTerm: string,
  resourceid?: Nullable<number>,
  resourcetype?: Nullable<string>,
  group?: Nullable<string>,
  applyFilters = true
): UsersSearchForm {
  return {
    applyFilters,
    group,
    resourceid,
    resourcetype,
    searchTerm,
  };
}

export function mapUsersSearchFormToQueryParameters(form: UsersSearchForm): string {
  const resourceidParam = form.resourceid ? `&resourceid=${form.resourceid}` : "";
  const resourcetypeParam = form.resourcetype ? `&resourcetype=${form.resourcetype}` : "";
  const groupParam = form.group ? `&group=${form.group}` : "";

  const searchParam = groupParam === "" ? "full_name__startswith" : "q";

  const queryString = `?${searchParam}=${form.searchTerm.toLowerCase()}`;

  return form.applyFilters
    ? `${queryString}${resourceidParam}${resourcetypeParam}${groupParam}`
    : queryString;
}
